// extracted by mini-css-extract-plugin
module.exports = {"header":"layout_header__NRLmg","mobileHeader":"layout_mobileHeader__NYMUi"};